import {useCallback} from 'react'
import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as actions from '../redux/reducers/chatbot/service'
import {
  FetchChatbotResponsesRequest,
  FetchActiveResponsesRequest,
  CreateChatbotResponseRequest,
  UpdateChatbotResponseRequest,
  DeleteChatbotResponseRequest,
  ToggleChatbotResponseStatusRequest,
  SearchChatbotResponsesRequest,
} from '../redux/reducers/chatbot/types'

export default function useChatbotRedux() {
  const dispatch = useAppDispatch()
  const {
    responses,
    responseForEdit,
    listLoading,
    actionLoading,
    error,
    total,
    totalPages,
  } = useAppSelector((state) => state.chatbot)

  const fetchResponses = useCallback((props: FetchChatbotResponsesRequest) => {
    return dispatch(actions.fetchChatbotResponses(props))
  }, [dispatch])

  const fetchActiveResponses = useCallback((props: FetchActiveResponsesRequest) => {
    return dispatch(actions.fetchActiveChatbotResponses(props))
  }, [dispatch])

  const createResponse = useCallback((props: CreateChatbotResponseRequest) => {
    return dispatch(actions.createChatbotResponse(props))
  }, [dispatch])

  const updateResponse = useCallback((props: UpdateChatbotResponseRequest) => {
    return dispatch(actions.updateChatbotResponse(props))
  }, [dispatch])

  const deleteResponse = useCallback((props: DeleteChatbotResponseRequest) => {
    return dispatch(actions.deleteChatbotResponse(props))
  }, [dispatch])

  const toggleStatus = useCallback((props: ToggleChatbotResponseStatusRequest) => {
    return dispatch(actions.toggleChatbotResponseStatus(props))
  }, [dispatch])

  const searchResponses = useCallback((props: SearchChatbotResponsesRequest) => {
    return dispatch(actions.searchChatbotResponses(props))
  }, [dispatch])

  return {
    // State
    responses,
    responseForEdit,
    listLoading,
    actionLoading,
    error,
    total,
    totalPages,
    
    // Actions
    fetchResponses,
    fetchActiveResponses,
    createResponse,
    updateResponse,
    deleteResponse,
    toggleStatus,
    searchResponses,
  }
}
